import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  recentSearchKeywordList: [],
  recommendedKeywordList: [],
  keywordRankList: [],

  filter: {
    // latitude: '',
    // longitude: '',
    STORE_ORDER_BY_CONDITION: '',
    STORE_DELIVERY_FEE_CONDITION: '',
    STORE_REQUIRED_PAY_AMOUNT_CONDITION: '',
    STORE_STAR_CONDITION: '',
    STORE_ETC_CONDITION: []
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
